import { Star } from 'lucide-react';
import { getReviews, type ReviewProductType, type VerifiedReview } from '@/data/verifiedReviews';

interface Props {
  type: ReviewProductType;
  collection?: VerifiedReview['collection'];
  title?: string;
  limit?: number;
  id?: string;
}

const Stars = () => (
  <div className="flex gap-0.5" aria-label="5 out of 5 stars">
    {Array.from({ length: 5 }).map((_, i) => (
      <Star key={i} className="w-4 h-4 fill-primary text-primary" aria-hidden="true" />
    ))}
  </div>
);

const VerifiedReviewsWall = ({ type, collection, title = 'What Players Say', limit = 12, id = 'reviews' }: Props) => {
  const reviews = getReviews(type, collection).slice(0, limit);
  if (!reviews.length) return null;

  return (
    <section id={id} className="py-16 md:py-20 bg-background" aria-labelledby={`${id}-heading`}>
      <div className="container mx-auto px-4">
        <div className="text-center mb-10">
          <h2 id={`${id}-heading`} className="text-3xl md:text-4xl font-bold text-foreground mb-3">{title}</h2>
        </div>
        <div className="grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {reviews.map((r) => (
            <article key={r.id} className="rounded-2xl border border-border bg-card p-6 flex flex-col gap-3">
              <Stars />
              {r.title && <h3 className="font-bold text-foreground">{r.title}</h3>}
              <p className="text-muted-foreground leading-relaxed flex-1">“{r.text}”</p>
              <div className="pt-3 border-t border-border text-sm">
                <div className="flex items-center gap-2">
                  <span className="font-semibold text-foreground">{r.name}</span>
                </div>
                <p className="text-muted-foreground text-xs mt-1">{r.product} · {r.when}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VerifiedReviewsWall;
